<template>
  <div style="float: right">
    <div class="file-button">
      <el-upload
        class="upload-button"
        :action="uploadUrl"
        :data="uploadData"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :headers="uploadHeader"
        :show-file-list="false"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="beforeUpload"
        v-if="importButton"
      >
        <el-button
          size="small"
          type="primary"
          plain
          v-loading.fullscreen.lock="fullscreenLoading"
          element-loading-text="导入中..."
          >{{ name }}</el-button
        >
      </el-upload>
      <el-button
        size="small"
        type="primary"
        plain
        @click="handleExport()"
        v-if="exportButton"
        :loading="downloading"
        >{{ exportBtnName }}</el-button
      >
      <el-button
        size="small"
        type="primary"
        plain
        @click="handleExport(true)"
        v-if="importButton"
        >{{ templateLabel }}</el-button
      >
    </div>
  </div>
</template>

<script>
import { fileExport } from '@/service/getData'
import { host, urlPerfix } from '@/config/env'
import store from '@/store/index'

export default {
  props: {
    obj: {
      type: String,
      default: '',
    },
    templateId: {
      type: Number,
      default: 0,
    },
    groupName: {
      type: String,
      default: null,
    },
    importButton: {
      type: Boolean,
      default: true,
    },
    exportButton: {
      type: Boolean,
      default: true,
    },
    filter: {
      type: Object,
    },
    name: {
      type: String,
      default: '导入',
    },
    templateLabel: {
      type: String,
      default: '下载模板',
    },
    exportBtnName: {
      type: String,
      default: '导出',
    },
  },
  data() {
    return {
      downloading: false,
      fullscreenLoading: false,
      host,
      // data: { obj: this.obj, templateId: this.templateId },
      uploadUrl: urlPerfix + '/files/import',
      uploadHeader: { Token: store.state.userInfo.token },
    }
  },
  computed: {
    uploadData() {
      return {
        obj: this.obj,
        templateId: this.templateId,
        group_name: this.groupName,
      }
    },
  },
  methods: {
    handleUploadSuccess(res, file) {
      this.fullscreenLoading = false
      if (res.code != 0) {
        this.$alert(`${res.data || '导入失败，请刷新页面重试'}`)
      } else {
        this.$emit('importCallback', res)
      }
    },
    handleUploadError() {},
    beforeUpload() {
      this.fullscreenLoading = true
    },
    async handleExport(temp = false) {
      let data = {
        obj: this.obj,
        template: temp,
      }

      data = Object.assign(data, this.filter)
      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }

      if (!temp) {
        this.downloading = true
      }
      let res = await fileExport(data)
      if (res.code == 0 && res.data) {
        this.downloading = false
        window.location.href = res.data
      }
    },
  },
}
</script>

<style>
.el-upload__input {
  display: none !important;
}
</style>

<style scoped>
.upload-button {
  margin-right: 10px;
}
.file-button {
  display: flex;
}
</style>